import { EditFrameMode } from '@synqo/frontend-component-library';

export function getFrameLabel(resourceName: string, mode: EditFrameMode): string {
    switch (mode) {
        case EditFrameMode.View:
            return resourceName;
        case EditFrameMode.Create:
            return `${resourceName} erfassen`;
        case EditFrameMode.Edit:
            return `${resourceName} bearbeiten`;
    }
}
